import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import {connect} from "trim-redux";
import Title from "../../../../components/elements/Title";
import {Box, Card, Typography} from "@mui/material";
import {currencySymbol, price} from "../../../../../config/values";
import AddStockPrice from "./AddStockPrice";
import StockPriceChart from "./StockPriceChart";
import SubTitle from "../../../../components/elements/SubTitle";
import {getDirection} from "../../../../../config/design/theme";
import clsx from "clsx";

function StockPricePage({setting}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageStockPrice')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={{xs:12,md:6}} className="bg-red-box p-20">
                    <SubTitle><strong>{t('todayStocksPrice')}</strong></SubTitle>
                   <div className="flex-direction gap-0 flex-column-xs">
                       <Box className="text-center stock-box">
                           <Title>{t('normal')}</Title>
                           <strong style={{fontSize:20}}>{price(setting.current_normal_price)} {currencySymbol}</strong>
                       </Box>
                       <Box className={clsx('text-center','stock-box', getDirection() === "rtl" ? 'brd-right' : 'brd-left')}>
                           <Title>{t('special')}</Title>
                           <strong style={{fontSize:20}}>{price(setting.current_special_price)} {currencySymbol}</strong>
                       </Box>
                   </div>
                </Grid>
                <Grid item size={{xs:12,md:6}}>
                    <AddStockPrice/>
                </Grid>
                <Grid item size={12}>

                </Grid>
                <Grid item size={12}>
                    <StockPriceChart/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
const mstp = (state) => ({
    setting: state.setting
});

export default withStyles(Styles)(connect(mstp)(StockPricePage));
